import {Component, Inject, OnInit} from '@angular/core';
import {ControlDialogOptionsHelper} from '../control-dialog-options-helper';
import {entiteTypeEnum} from '../../../../../enum/entite-type.enum';
import {SubSink} from '@Common/core/utils/subsink';
import {FieldConfigName} from '../../../models';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-svc-cmp-input-dialog',
  templateUrl: './svc-cmp-input-dialog.component.html',
  styleUrls: ['./svc-cmp-input-dialog.component.scss']
})
export class SvcCmpInputDialogComponent extends ControlDialogOptionsHelper implements OnInit {
  editSvcCmpInputForm: UntypedFormGroup;
  formArray: UntypedFormArray;
  control: FieldConfigName;
  extraParams: Map<string, string> = new Map<string, string>();
  subSink = new SubSink();
  entiteTypeEnum = entiteTypeEnum;
  status: boolean;
  // tslint:disable-next-line:no-bitwise
  SVC_CMP = entiteTypeEnum.cmp | entiteTypeEnum.dir;
  constructor(private formBuilder: UntypedFormBuilder,
              public dialogRef: MatDialogRef<SvcCmpInputDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    super();
    if (data) {
      this.control = data.control || this.control;
    }
  }
  ngOnInit(): void {
    this.validateFormBuilder();
    this.editProperty(this.control);
  }
  validateFormBuilder(): void {
    const formGroup = <any>{
      tooltip: ['', []],
      label: ['', []],
      placeholder: ['', []],
      isRequired: [false],
      options: ['', []],
      entite:  [this.entiteTypeEnum.dir, []]
    };
    this.editSvcCmpInputForm = this.formBuilder.group(formGroup);
  }
  editProperty(control: any): void {
    this.status = control.options.isRequired;
    const formValues = <any>{
      tooltip: control.options.tooltip,
      label: control.options.label,
      placeholder: control.options.placeholder,
      isRequired: control.options.isRequired,
      options: control.options?.options || '',
      entite: control.options.entite
    };
    this.editSvcCmpInputForm.setValue(formValues);
  }
  onSubmit(): void {
    if (this.editSvcCmpInputForm.invalid) {
      return;
    }
    this.dialogRef.close(this.editSvcCmpInputForm.value);
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}
